import fetch from '../utils/fetch'

/* 到店签到活动管理 */

// 活动列表
export function getStoreSigninActivityList (query) {
  return fetch({
    url: '/storeSigninActivity/list',
    method: 'get',
    params: query
  })
}

// 新增活动
export function addStoreSigninActivity (query) {
  return fetch({
    url: '/storeSigninActivity/save',
    method: 'post',
    data: query
  })
}

// 编辑活动
export function editStoreSigninActivity (query) {
  return fetch({
    url: '/storeSigninActivity/edit',
    method: 'post',
    data: query
  })
}

// 删除活动
export function delStoreSigninActivity (id) {
  return fetch({
    url: '/storeSigninActivity/del/' + id,
    method: 'delete'
  })
}

/* 到店签到记录 */

export function storeSigninLogList (query) {
  return fetch({
    url: '/storeSigninLog/list',
    method: 'get',
    params: query
  })
}

/* 到店签到奖励列表 */

export function storeSigninAwardList (query) {
  return fetch({
    url: '/storeSigninAwardLog/list',
    method: 'get',
    params: query
  })
}

// 补发奖励
export function resendStoreSigninAward (query) {
  return fetch({
    url: '/storeSigninAwardLog/send',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/store_sign.js